// frontend/src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center">
            <div className="h-8 w-8 rounded-md bg-indigo-100 flex items-center justify-center">
              <span className="text-sm font-bold text-indigo-700">ZEE</span>
            </div>
            <span className="ml-2 text-sm text-gray-500">© {new Date().getFullYear()} ZEE FAST Analytics</span>
          </div>
          
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              <li>
                <a href="#help" className="text-sm text-gray-500 hover:text-gray-700">
                  Help
                </a>
              </li>
              <li>
                <a href="#docs" className="text-sm text-gray-500 hover:text-gray-700">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-gray-500 hover:text-gray-700">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-gray-500 hover:text-gray-700">
                  Terms
                </a>
              </li>
            </ul>
          </div>
          
          <div className="mt-4 md:mt-0">
            <span className="text-xs text-gray-400">Version 1.0.0-beta</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
